import React from 'react';
import Icon from '../../../components/dashboard/DashboardIcons';

export default function KpiCard({ icon, label, value, sub, accent = 'text-slate-900', testId }) {
  return (
    <div className="min-h-[104px] rounded-xl border border-slate-200 bg-white p-4" data-testid={testId}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold text-slate-500">{label}</span>
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#16233b]/5 text-[#16233b]">
          <Icon name={icon} className="w-4 h-4" />
        </span>
      </div>
      <div className={`mt-2 break-words text-lg leading-tight sm:text-2xl font-bold ${accent}`} dir="rtl">{value}</div>
      {sub && <div className="mt-1 text-xs text-slate-400">{sub}</div>}
    </div>
  );
}
